import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';

// Stage 6A v6 — broadcast delete confirmation. Now built on the shadcn Dialog
// (Design System v1 Phase 2F): Radix handles the overlay, focus trap, Esc and
// the close button, so the bespoke fixed-overlay + manual keydown handling is
// gone. Copy is supplied by the caller (deleteConfirmCopy keys it on draft vs
// sent). Confirm uses the destructive variant; Cancel is outline. Default
// focus lands on the close button (not the destructive action), so a
// muscle-memory Enter doesn't delete.

type Props = {
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  busy?: boolean;
  errorText?: string | null;
};

export function ConfirmDeleteModal({
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  busy,
  errorText,
}: Props) {
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        // Esc / overlay click / close button → cancel (unless mid-delete).
        if (!open && !busy) onCancel();
      }}
    >
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>
        {errorText && <p className="text-sm text-destructive">{errorText}</p>}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={busy}>
            {busy ? 'Deleting…' : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
